import { ActiveOperationsBanner } from '@/components/banners/ActiveOperationsBanner';
import { OfflineIndicator } from '@/components/banners/OfflineIndicator';
import { PWAInstallPrompt } from '@/components/banners/PWAInstallPrompt';
import { PWAUpdatePrompt } from '@/components/banners/PWAUpdatePrompt';
import { RateLimitBanner } from '@/components/banners/RateLimitBanner';
import { ConfirmationDialog } from '@/components/shared/ConfirmationDialog';
import { TransactionDetailModal } from '@/components/transactions/TransactionDetailModal';
import { type AuthContextType } from '@/context/auth-context';
import { RateLimitProvider } from '@/context/rate-limit-context';
import appServices from '@/services/appServices';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

export interface MyRouterContext {
  // The ReturnType of your useAuth hook or the value of your AuthContext
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <RateLimitProvider>
      <RateLimitBanner />
      <Outlet />
      <>
        <ConfirmationDialog />
        <PWAInstallPrompt />
        <PWAUpdatePrompt />
        <OfflineIndicator />
        {/* <PWADebugPanel /> */}
        <TransactionDetailModal />
        <ActiveOperationsBanner />
      </>
    </RateLimitProvider>
  ),
  beforeLoad: async () => {
    await appServices.auth.initialize();
  },
});
